import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Select from 'react-select-v3';

import { getFilteredRoutes } from 'reselects';

import { isLocalOrCorridorAndDefinedAndEnabled } from 'reselects/routes';

import { StyledFilter, reactSelectStyles } from './styled';
import { specialRoutes, isSpecialRoute } from 'utils/filters/getRoutesFilter';
import { injectIntl } from 'react-intl';

import _ from 'lodash';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';

const enhance = compose(
  connect((state) => ({
    routes: getFilteredRoutes(state, isLocalOrCorridorAndDefinedAndEnabled),
  }))
);

const removeFilters = (routes, filtersToRemove) => {
  return (routes || []).filter((route) => !(filtersToRemove || []).includes(route.value));
};

const RouteFilter = ({
  className,
  selectProps = {},
  value,
  routes = [],
  onChange,
  stylingProps,
  intl,
}) => {
  const t = intl.messages.modules.Filters.route;
  const defaultRoute = { label: t.default_route, value: 'all' };
  const defaultValue = (value || []).length ? value : defaultRoute;
  const isLhFilterEnabled = useSelector((store) =>
    getSpecificClientConfig(store, constants.LH_FILTER)
  );

  /**
   * Handle the onChange event
   * @param {Array[filter]} newFilters contains the new filters of the Select
   * @param {Array[filter]} prevFilters contains the previous filters of the Select
   */
  const handleChange = (newFilters, prevFilters) => {
    const lastNewFilter = _.last(newFilters);
    if (newFilters?.length && prevFilters?.length) {
      const lastPrevFilter = _.last(prevFilters);
      // if the new filter or the previous filters contains an special filter the previous filters must be removed
      if (isSpecialRoute(lastNewFilter.value) || isSpecialRoute(lastPrevFilter.value)) {
        newFilters = [lastNewFilter];
      }
    }
    // 'all' filter is removed because we don't allow all + route.
    onChange(removeFilters(newFilters, ['all']));
  };

  const mappedRoutes = routes.map((route) => ({
    label: route.simple_name,
    value: route.symmetric_name,
  }));

  const routeOptions = [
    ...mappedRoutes, // routes from BE (MAD, BCN, ...)
    ...specialRoutes, // special routes defined in filter utils (LH, INT, ...)
  ];

  return (
    <StyledFilter className={className} {...stylingProps}>
      <Select
        value={defaultValue}
        closeMenuOnSelect
        isMulti
        options={isLhFilterEnabled ? routeOptions : mappedRoutes}
        onChange={(change) => handleChange(change, value)}
        styles={reactSelectStyles}
        placeholder={t.placeholder}
        {...selectProps}
      />
    </StyledFilter>
  );
};

RouteFilter.filterName = 'RouteFilter';

RouteFilter.defaultProps = {
  value: '',
  routes: [],
};

export default injectIntl(enhance(RouteFilter));
